import { render, staticRenderFns } from "./SingleReserves.vue?vue&type=template&id=fbd2a5b6&scoped=true&"
import script from "./SingleReserves.vue?vue&type=script&lang=js&"
export * from "./SingleReserves.vue?vue&type=script&lang=js&"
import style0 from "./SingleReserves.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SingleReserves.vue?vue&type=style&index=1&id=fbd2a5b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd2a5b6",
  null
  
)

component.options.__file = "SingleReserves.vue"
export default component.exports